const axios = require('axios');
const xml2js = require('xml2js');

/**
 * Utility to validate GPX files from a URL
 * @param {string} url - URL of the GPX file
 * @returns {Promise<boolean>} - Resolves to true if valid, otherwise false
 */
async function validateGPXFileFromURL(url) {
  try {
    const response = await axios.get(url);
    const fileContent = response.data;
    const parser = new xml2js.Parser();

    const result = await parser.parseStringPromise(fileContent);

    // Check if the root element is 'gpx'
    if (!result.gpx) {
      throw new Error('Invalid GPX file: Missing <gpx> root element');
    }

    // Additional validation logic can be added here
    return true;
  } catch (error) {
    console.error(`GPX Validation Error: ${error.message}`);
    return false;
  }
}

module.exports = validateGPXFileFromURL;